import styled from "styled-components"

const Header = ({ title }) => {
  return (
    <div className=" mb-3">
      <Container>
        <TitleContainer>
          <Text className="text-center mt-2 mb-2 heading lead">
            {title === "League" ? "League Table" : title}
          </Text>
        </TitleContainer>
      </Container>
    </div>
  )
}

export default Header

const Container = styled.div`
  padding: 0rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: transparent;
`
const TitleContainer = styled.div``
const Text = styled.h2`
  margin: 0;
  padding: 1rem 2rem;
  border: 2px solid #5fa8e6;
  background: linear-gradient(120deg, #1a1c28 60%, #0f1219 100%);
  box-shadow: 0 0 4px 1px #00eaff;
  border-radius: 8px;
  color: #00eaff;
  letter-spacing: 1px;
`
